"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault")["default"];
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalVariant = void 0;
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));
var ModalVariant = /*#__PURE__*/(0, _createClass2["default"])(function ModalVariant(modalRef) {
  (0, _classCallCheck2["default"])(this, ModalVariant);
  if (!modalRef) throw 'Missing modal reference';
  this.modal = modalRef;
});
exports.ModalVariant = ModalVariant;
//# sourceMappingURL=ModalVariant.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@3cad/nextcore/lib/commonjs/controllers/ModalVariant.js
// module id = 1245
// module chunks = 142